// src/pages/AgeingReport/components/exportAgeingCsv.js
import commaNumber from "comma-number";

const format = commaNumber.bindWith(",", ".");
const fmt = (val) => format(parseFloat(val || 0).toFixed(2));

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

/**
 * @param {object} params
 * @param {Array}   params.list          - customerList or vendorList from Redux
 * @param {number}  params.totalBalance  - customerTotalBalance or vendorTotalBalance
 * @param {string}  params.mode          - "customer" | "vendor"
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportAgeingCsv = ({
  list,
  totalBalance,
  mode = "customer",
  title    = "Ageing Report",
  filename = "ageing_report",
}) => {
  const isCustomer = mode === "customer";

  const headers = [
    "No.",
    ...(isCustomer ? ["Code"] : []),
    isCustomer ? "Customer Name" : "Vendor Name",
    "Contact", "Address", "Opening",
    "Current (0-30d)", "31-60 Days", "61-90 Days", "90+ Days",
    "Total Balance",
  ].map(escape);

  const dataRows = list.map((row, i) => [
    i + 1,
    ...(isCustomer ? [row.acc_code || ""] : []),
    row.acc_name        || "",
    row.contact_no      || "",
    row.address         || "",
    fmt(row.opening_balance),
    fmt(row.current),
    fmt(row.days31_60),
    fmt(row.days61_90),
    fmt(row.days90plus),
    fmt(row.balance),
  ].map(escape));

  const totals = list.reduce(
    (acc, row) => ({
      opening: acc.opening + parseFloat(row.opening_balance || 0),
      current: acc.current + parseFloat(row.current         || 0),
      d31_60:  acc.d31_60  + parseFloat(row.days31_60       || 0),
      d61_90:  acc.d61_90  + parseFloat(row.days61_90       || 0),
      d90plus: acc.d90plus + parseFloat(row.days90plus      || 0),
    }),
    { opening: 0, current: 0, d31_60: 0, d61_90: 0, d90plus: 0 }
  );

  const totalRow = [
    "Grand Total",
    ...(isCustomer ? [""] : []),   // blank Code column for customers
    "", "", "",                    // Name, Contact, Address
    fmt(totals.opening),
    fmt(totals.current),
    fmt(totals.d31_60),
    fmt(totals.d61_90),
    fmt(totals.d90plus),
    fmt(totalBalance),
  ].map(escape);

  const rows = [
    [title],
    [],
    headers,
    ...dataRows,
    [],
    totalRow,
  ];

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};